import { useState } from 'react';

import TopModalSection from '../common/TopModalSection';

import ProductForm from '@/components/forms/product/ProductForm';
import { IStore } from '@/interfaces/api/IStore';
import { ICreateProductPayload } from '@/interfaces/api/product/ICreateProductPayload';
import { haggleApiService } from '@/services/haggle.service';
import { notificationService } from '@/services/notification.service';

type Props = {
	defaultClose: () => void;
	refetchProducts?: () => void;
	store: IStore | undefined;
};

const CreateProductModal = ({
	defaultClose,
	refetchProducts,
	store,
}: Props) => {
	const [isLoading, setIsLoading] = useState(false);

	const handleCreateSubmit = async (values: ICreateProductPayload) => {
		setIsLoading(true);
		try {
			if (!store) {
				throw new Error('Store is required');
			}

			// Get current epoch time in seconds
			const epochTime = Math.floor(Date.now() / 1000);

			// Format store name and product title
			const formattedStoreName = store.name.toLowerCase().replace(/\s+/g, '-');
			const formattedTitle = values.title.toLowerCase().replace(/\s+/g, '-');

			const handle = `${formattedStoreName}-${formattedTitle}-${epochTime}`;
			// Create product handle
			values.handle = handle;
			values.published = true;
			// values.vendor = store.name;

			// Update variant handles
			values.variants = values.variants.map((variant) => ({
				...variant,
				handle: handle,
			}));

			await haggleApiService.createProduct(values);
			notificationService.success('Product created successfully');
			defaultClose();
			await refetchProducts?.();
		} catch (error) {
			if (error instanceof Error) {
				notificationService.error(error.message);
			} else {
				notificationService.error(
					`Unknown error when trying to create a Product: ${error}`,
				);
			}
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<div className="flex flex-col justify-center items-center w-full max-w-3xl">
			<TopModalSection
				className="gap-x-4 border-b py-2 w-full px-4"
				title="Add New Product"
				close={defaultClose}
			/>
			{/* Optionally, add a loading skeleton here if needed */}
			{/* {isLoading && <LoadingSkeletonProductForm />} */}
			<div className="relative z-0 w-full">
				<ProductForm
					handleSubmit={handleCreateSubmit}
					loading={isLoading}
					setIsLoading={setIsLoading}
					closeModal={defaultClose}
				/>
			</div>
		</div>
	);
};

export default CreateProductModal;
